import { useEffect, useState } from 'react';

import { useProductData } from 'hooks/api/use-product-data';

import { getDaysUntilMigration, getTextAppProduct } from './helpers';

const DAY_MS = 24 * 60 * 60 * 1000;

export function useMigrationDaysLeft(): number {
  const [now, setNow] = useState(Date.now);
  const { installedProducts } = useProductData();
  const createdAt = getTextAppProduct(installedProducts)?.created_at ?? new Date(now - 4 * DAY_MS).toISOString(); // TEMP: 3 days left for local testing
  const daysLeft = getDaysUntilMigration(createdAt, now);

  useEffect(() => {
    if (daysLeft <= 0) return;

    const createdAtMs = new Date(createdAt).getTime();
    const msUntilNextBoundary = DAY_MS - ((now - createdAtMs) % DAY_MS);
    const timerId = window.setTimeout(() => setNow(Date.now()), msUntilNextBoundary);

    return () => window.clearTimeout(timerId);
  }, [daysLeft, now, createdAt]);

  return daysLeft;
}
